import { SyntheticEvent, useCallback } from 'react';
import Fade from '@mui/material/Fade';
import { XAlert } from 'xsolis-component-library';

import { useAppDispatch } from '@/store/hooks';

import { snackbarActions, useSnackbarSelector } from './Snackbar.slice';
import { SnackbarStyled } from './Snackbar.style';

export const Snackbar = () => {
  const { closeCallback, duration, message, open, type } =
    useSnackbarSelector();

  const dispatch = useAppDispatch();

  const handleClose = useCallback(
    (_: SyntheticEvent, reason?: string) => {
      if (reason === 'clickaway') return;
      dispatch(snackbarActions.RESET());
      if (closeCallback) closeCallback();
    },
    [dispatch, closeCallback]
  );

  if (!type) return null;

  return (
    <SnackbarStyled
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      autoHideDuration={duration}
      onClose={handleClose}
      open={open}
      TransitionComponent={Fade}
    >
      <XAlert
        data-testid='snackbar-message'
        onClose={handleClose}
        severity={type}
      >
        {message}
      </XAlert>
    </SnackbarStyled>
  );
};
